import { mobile } from 'common/styles/breakpoints';
import {
  lighterNavy,
  tableBodyGrey,
  tableHeaderGrey,
} from 'common/styles/colors';
import styled from 'styled-components';
import { AddSettingInput } from '../../styles';

export const MonthSwitcherWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 30px;
  width: 100%;

  @media (max-width: ${mobile}) {
    flex-direction: column;
    margin-left: 0;
  }
`;

export const EffectiveText = styled.span`
  margin-left: 5px;
  font-family: KanitSemibold;
  font-size: 18px;
  color: ${lighterNavy};
  text-wrap: nowrap;
  margin-left: 20px;

  @media (max-width: ${mobile}) {
    margin-left: 0;
  }
`;

export const CenteredText = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: KanitLight;
  font-size: 16px;
  color: ${tableBodyGrey};
`;

export const CenteredHeader = styled(CenteredText)`
  font-family: KanitSemiBold;
  color: ${tableHeaderGrey};
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: nowrap;
  width: 100%;

  .invalid-feedback {
    display: flex;
  }
`;

export const TrsfRateInputWrapper = styled(InputWrapper)`
  flex-wrap: wrap;
  justify-content: space-between;
  padding-right: 10px;
`;

export const RouteInput = styled(AddSettingInput)`
  height: 30px;
  max-width: 200px;
`;
